module.exports = __webpack_public_path__ + "static/media/ic_checkBox_green.41959b33.svg";